import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";

import { NavBar } from "./nav-bar";
import { DfpAd } from "../dfp-ad/";

import "./header.m.css";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.
class HeaderBase extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div styleName="ad-top">
          <DfpAd adtype="NH_HP_728x90" />
        </div>
        <div styleName="container">
          <NavBar {...this.props} />
        </div>
      </React.Fragment>
    );
  }
}

function getCoupletSummary(state) {
  const coupletSummary = get(state, ["qt", "data", "getCoupletSummary"], "");
  const splitBySlash = coupletSummary && coupletSummary.split("/");
  return splitBySlash;
}

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    coupletSummary: getCoupletSummary(state)
  };
}

export const Header = connect(
  mapStateToProps,
  () => ({})
)(HeaderBase);
